import React from "react";
import TeamSection from "../components/TeamSection/team";

const TeamPage = () => {
  return (
    <>
      <TeamSection />
    </>
  );
};

export default TeamPage;
